const formatNumber = (value, locale, decimalPlaces = 2, minDecimalPlaces = null) => {
  const minimumDecimalPlaces = minDecimalPlaces === null ? decimalPlaces : minDecimalPlaces;

  return new Intl.NumberFormat(
    locale, {
      minimumFractionDigits: minimumDecimalPlaces,
      maximumFractionDigits: decimalPlaces,
      style: 'decimal',
      useGrouping: true,
    },
  ).format(value);
};

export const getNumberSeparators = (locale) => {
  const formatter = new Intl.NumberFormat(locale, {
    style: 'decimal',
    useGrouping: true,
  });

  // Check if formatToParts is supported
  if (typeof formatter.formatToParts === 'function') {
    const parts = formatter.formatToParts(1234.5);
    const thousandSeparator = parts.find(part => part.type === 'group')?.value || '';
    const decimalSeparator = parts.find(part => part.type === 'decimal')?.value || '';

    return {
      thousandSeparator,
      decimalSeparator,
    };
  }

  const formattedNumber = formatter.format(1234.5);
  let thousandSeparator = '';
  let decimalSeparator = '.';

  const thousandMatch = formattedNumber.match(/1(.?)234/);
  if (thousandMatch) {
    [, thousandSeparator] = thousandMatch;
  }

  const decimalMatch = formattedNumber.match(/4(.?)5/);
  if (decimalMatch) {
    [, decimalSeparator] = decimalMatch;
  }

  return {
    thousandSeparator,
    decimalSeparator,
  };
};

export default formatNumber;
